import { OTPProps } from "antd/es/input/OTP";
import { Input } from "antd";
import { useEffect, useRef } from "react";

const OTP = ({ ...props }: OTPProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.querySelectorAll("input").forEach((input) => {
      input.setAttribute("inputmode", "numeric");
      input.setAttribute("pattern", "[0-9]*");
      input.setAttribute("autocomplete", "one-time-code");
    });
  }, [props.length, props.value]);

  return (
    <div ref={ref} className="app-otp">
      <Input.OTP
        size="large"
        {...props}
        type="number"
        inputMode="numeric"
      />
    </div>
  );
};

export default OTP;
